<style>
  .zoomBackground {
    animation: zoomBackground 1s linear forwards;
    animation-iteration-count: 1;
    background-position: center;
  }

  .unzoomBackground {
    animation: unzoomBackground 1s linear forwards;
    animation-iteration-count: 1;
    background-position: center;
  }
  @keyframes zoomBackground {
    0% {
      background-size: 100% var(--initialZoom);
      background-position: var(--initialPosition);
    }
    100% {
      background-size: 100% 180%;
      background-position: top;
    }
  }

  @keyframes unzoomBackground {
    0% {
      background-size: 100% var(--initialZoom);
      background-position: var(--initialPosition);
    }
    100% {
      background-size: 100% 100%;
      background-position: center;
    }
  }

  #dezoom {
    -webkit-transform: scale(0.9);
    -moz-transform: scale(0.9);
    -o-transform: scale(0.9);
    transform: scale(0.9);
    transform-origin: top;
  }
</style>

<main id='main' class='h-screen min-h-screen overflow-hidden {backgroundClass} relative z-0' style="background-image: linear-gradient(rgb(17, 24, 36), rgb(39, 61, 124), rgb(17, 24, 36)); --initialZoom: {initialZoom}; --initialPosition: {initialPosition};">
  <Fireflies />
  <div id='dezoom' class='sm:pb-24 md:pb-36' style='height: 111%;'>
    <div style='height: 10%;'>
      <Navbar />
    </div>

    <div class='flex flex-col justify-center items-center' style='height: 75%'>
      <Notification />
      <Router {routes} /> 
    </div>
  </div>
  <Waves />
  <DataMonitor />
</main>

<script>
  import Navbar from './components/navbar.svelte';
  import Waves from './components/waves.svelte';
  import Router from 'svelte-spa-router';
  import {location} from 'svelte-spa-router'
  import routes from './routes'
  import { connected } from './stores.js';
  import Fireflies from './components/fireflies.svelte';
  import DataMonitor from './components/dataMonitor.svelte';
  import Notification from './components/notification.svelte';

  $: backgroundClass = $location && ($location == '/' || $location == '/Index') ? 'unzoomBackground' : 'zoomBackground'
  $: initialZoom     = $location && ($location == '/' || $location == '/Index') ? (fetchInitialZoom()     ? '100%'    : '100%')   : (fetchInitialZoom()     ? '100%'    : '180%');
  $: initialPosition = $location && (fetchInitialPosition() ? '50% 50%' : '50% 0%');

  function fetchInitialZoom() {
    if (document.getElementById('main')) {

      var backgroundSize = window.getComputedStyle(document.getElementById('main')).getPropertyValue('background-size').split(' ')[1]
      return backgroundSize;
    }
  }

  function fetchInitialPosition() {
    if (document.getElementById('main')) {

      var backgroundPosition = window.getComputedStyle(document.getElementById('main')).getPropertyValue('background-position')
      return backgroundPosition;
    }
  }
</script>
